<template>
  <div>
    <h2 class="page-title mb-4">Routines</h2>

    <h5 class="page-h5-titlenew">Set up routine for your team members. Use our template library below to set started quickly or create your guru.</h5>
    <section class="widget">
      <b-row>
        <b-col sm="12">
          <h5 class="text-tagnew font-semibold mt-3 mb-4">Templates:</h5>
          <b-row>
           <b-col xs='12' md='6'>
               <div class="templates-div">
               <button
                    data-v-6d85d69b
                    type="button"
                    class="btn btn-success templates-page-btn edit-access"><i class="fa fa-list" aria-hidden="true"></i>Front desk daily Routine</button>
                  <button
                    data-v-6d85d69b
                    type="button"
                    class="btn btn-success templates-page-btn edit-access"><i class="fa fa-list" aria-hidden="true"></i>Front desk closing Checklist</button>
                  <button
                    data-v-6d85d69b
                    type="button"
                    class="btn btn-success templates-page-btn edit-access"><i class="fa fa-list" aria-hidden="true"></i>Front desk weekly Checklist</button>
               </div>
           </b-col>
           <b-col xs='12' md='6'>
               <div class="templates-div">
               <button
                    data-v-6d85d69b
                    type="button"
                    class="btn btn-success templates-page-btn edit-access"><i class="fa fa-list" aria-hidden="true"></i>Tx coordinator weekly Checklist</button>
                  
               </div>
           </b-col>
          </b-row>
        </b-col>
      </b-row>
    </section>
    <section class="widget">
      <b-row>
        <b-col sm="12">
          <h5 class="text-tagnew font-semibold mt-3 mb-4">Your Routines:</h5>
          <b-row>
           <b-col xs='12'>
               <div class="upload-btn-wrapper">
              <button data-v-6d85d69b="" type="button" class="btn upload-asset-btn edit-access add-routine-btn" @click="gotoCreateRoutine()">
                <i aria-hidden="true" class="fa fa-plus"></i>Add New Routine
              </button>
            </div>
           </b-col>
           <b-col sm="12">
              <div class="table-responsive mt-3">
                <table class="table table-hover" v-if="routines && employees">
                  <thead>
                    <tr>
                      <th>Routine</th>
                      <th>Repeats</th>
                      <th>Assigned To:</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(routine, index) in routines" :key="`routine-${index}`">
                      <td>
                        <div class="text-routine-table">
                          <router-link :to="{ name: 'ViewRoutine', params: {routineID:  `${routine.RoutineID}`} }">
                            <button type="button" class="btn btn-link">
                              <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                            </button>
                          </router-link>
                          <router-link :to="{ name: 'ViewRoutine', params: {routineID:  `${routine.RoutineID}`} }">
                            <button type="button" class="btn btn mr-xs btn-default"><i class="fa fa-list" aria-hidden="true"></i>{{routine.Name}}</button>
                          </router-link>
                        </div>
                      </td>
                      <td>
                        <span>
                          <i class="fa fa-refresh" aria-hidden="true"></i>{{routine.Repeats}}
                        </span>
                      </td>
                      <td>
                        <span>
                          <i class="fa fa-user-circle-o" aria-hidden="true"></i>{{getAssignedToEmployee(routine.AssignedToEmpID)}}
                        </span>
                        <!--
                        <span>
                          <i class="fa fa-user-circle-o" aria-hidden="true"></i>Tina Jones ,
                        </span>
                        <span>
                          <i class="fa fa-user-circle-o" aria-hidden="true"></i>Nicholes Card
                        </span>
                        -->
                      </td>
                    </tr>                    
                  </tbody>
                </table>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ErrorDisplay from "@/components/ErrorDisplay/ErrorDisplay";
import mixin from '../../mixin.js';

export default {
  name: "Routines",
  components: { ErrorDisplay },
  mixins: [mixin],

  created() {
    this.init();
  },

  methods: {
    ...mapActions('routines', ['getRoutines', 'deleteRoutine']),

    async init() {
      await this.getRoutines({siteID: this.siteID});
    },

    gotoCreateRoutine() {
      this.$router.push('/app/createroutine');
    },

    getAssignedToEmployee(id) {
      return this.employees.filter(e => e.EmployeeID === id)[0].Name;
    }
  },

  computed: {
    ...mapState({
        routines: state => state.routines.routines,
    }),
  }
};
</script>

<style src="./Routine.scss" lang="scss" />

